import { V2 } from '~/src/geometry/vector';
import * as Vec from '~/src/geometry/vector';
import { p } from '~/src/geometry/point';
import { comp , constant } from '~/src/base/Function';
import { get1 } from '~/src/base/Optic';

import State from '../State';
import * as St from '../State';


export interface Pan {
	tag : 'Pan';
	set : boolean;
	val : V2;
}

export const pan = ( val : V2 , set ?: boolean ) : Pan =>
	( { tag : 'Pan' , set : set ?? false , val } );

export const exePan = ( state : State , cmd : Pan ) : State => {
	const delZoom = St._delZoom( get1( St.zoom )( state ) );

	return comp(
		St.ctrd( constant( false ) ),
		St.pan( pan => cmd.set ? cmd.val : Vec.v2_add( delZoom( p( cmd.val ) ) )( pan ) ),
	)( state );
};
